export default "__VITE_ASSET__CVaHeo$J__"